<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Acesso/Departamentos</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            color="info"
            to="/departamento/criar"
            v-if="isAllowed(1)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="departamentos.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="departamentos.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.requisicao="{ item }">
          {{ item.requisicao ? "Sim" : "Não" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(1)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { downloadLista } from "../../../services/departamentoService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listadepartamentos",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      active_tab: 2,
      headers: [
        {
          text: "Id", align: "start", value: "id",
        },
        { text: "Departamento", value: "descricao" },
        { text: "Requisição", value: "requisicao" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        descricao: [],
      },
    };
  },
  computed: {
    ...mapState("departamento", ["departamentos"]),
    filteredList() {
      if (this.showAtivo === false) {
        var newList = this.departamentos.filter((d) => {
          return (
            d.descricao.toLowerCase().includes(this.search.toLowerCase()) &&
            d.ativo === true
          );
        });
        return newList.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        var novaLista = this.departamentos.filter((d) => {
          return d.descricao.toLowerCase().includes(this.search.toLowerCase());
        });
        return novaLista.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
  },
  methods: {
    ...mapActions("departamento", ["atualizarDepartamentos", "atualizarDepartamento"]),
    editar(departamento) {
      this.atualizarDepartamento(departamento);
      if (this.isAllowed(1)) {
        this.$router.push(`/departamento/editar`);
      } else {
        this.$router.push(`/departamento/ver`);
      }
    },
    baixarlista() {
      //downloadLista();
      
      const blob = this.gerarExcel();
      const nome_arquivo = "departamentos.xlsx";
      saveAs(blob, nome_arquivo);
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarDepartamentos();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
    
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "Id" },
        { chave: "descricao", cabecalho: "Departamento" },
        { chave: "requisicao", cabecalho: "Requisição" },
        { chave: "status", cabecalho: "Status" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "id") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col, i) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacao,
  },
};
</script>
